export default __webpack_public_path__ + "static/media/razorPayX.0b621d80.svg";